import { Form, Field } from 'react-final-form';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { ModalWrapper } from '../../../../../components';
import { FormTextAreaField } from '../../../../../components/Form';
import { maxLength } from '../../../../../utils/validators';
import { modalsToggle } from '../../../../../actions';
import { InfoIcon } from '../../../../../components/Icons';
import { useUpdateDoNotRunNoteMutation } from '../../../../../services/api/vehicle-do-not-run';
import { useVehicleListContext } from '../../context';
import { Vehicle } from '../../../../../types/vehicle';

const noteMaxLen = maxLength(120);

const StyledTextAreaField = styled(Field)`
  background: #f5f5f5;
  width: 100%;
  display: flex;
  padding-left: 8px;
  margin-top: 5px;
  border-radius: 4px;
  font-size: 16px;
`;

const StyledLabel = styled(Typography)`
  color: #757575;
  font-weight: 500;
  font-size: 16px;
`;

const HelperTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  justify-content: flex-end;
`;

const StyledHelperText = styled(Typography)`
  color: #757575;
  font-weight: 400;
  font-size: 12px;
`;

type Props = { vehicle: Vehicle };

export const EditNoteModal = ({ vehicle }: Props) => {
  const modalName = `doNotRunNoteModal-${vehicle.id}`;
  const dispatch = useDispatch();
  const { localUpdate } = useVehicleListContext();
  const [updateNote] = useUpdateDoNotRunNoteMutation();

  const onSubmit = async (values: { do_not_run_note?: string }) => {
    const note = values.do_not_run_note ?? '';
    try {
      await updateNote({ vehicleId: vehicle.id, note }).unwrap();
      localUpdate(vehicle.id, { do_not_run_note: note });
      dispatch(modalsToggle(modalName));
      toast.success('Note saved.');
    } catch (e) {
      toast.error('Could not save note.');
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ do_not_run_note: vehicle.do_not_run_note ?? '' }}
      render={({ handleSubmit, submitting }) => (
        <ModalWrapper
          // @ts-ignore — ModalWrapper is untyped JS
          title="Do Not Run — Reason"
          submitting={submitting}
          handleSubmit={handleSubmit}
          modalId={modalName}
        >
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                <StyledLabel>Reason</StyledLabel>
                <HelperTextContainer>
                  <StyledHelperText>Max. 120 characters</StyledHelperText>
                  <InfoIcon />
                </HelperTextContainer>
              </Grid>
              <StyledTextAreaField
                name="do_not_run_note"
                // @ts-ignore — FormTextAreaField is untyped
                component={FormTextAreaField}
                disableUnderline
                fullWidth
                validate={noteMaxLen}
                rows={4}
              />
            </Grid>
          </Grid>
        </ModalWrapper>
      )}
    />
  );
};

export default EditNoteModal;
